export const risksEndpoints = {
  listRisks: { method: 'get', path: '/' },
  getRisk: { method: 'get', path: '/{riskId}' },
  createRisk: { method: 'post', path: '/' },
  updateRisk: { method: 'post', path: '/{riskId}' },
  deleteRisk: { method: 'post', path: '/{riskId}/delete' },
  getRiskSettings: { method: 'get', path: '/settings' },
  upsertRiskSettings: { method: 'post', path: '/settings' },
  listAlerts: { method: 'post', path: '/alerts' },
  updateAlert: { method: 'post', path: '/alerts/{alertId}' },
  getRiskAlertSettings: { method: 'get', path: '/alerts/settings' },
  updateRiskAlertSettings: { method: 'post', path: '/alerts/settings' },
  getProviderCredentials: { method: 'get', path: '/alerts/provider-credentials/{provider}' },
  upsertProviderCredentials: { method: 'post', path: '/alerts/provider-credentials/{provider}' },
  listCasesBySupplierId: { method: 'get', path: '/cases/supplier/{supplierId}' },
  listAlertsBySupplierId: { method: 'get', path: '/alerts/supplier/{supplierId}' },
  createCasesBulk: { method: 'post', path: '/cases/bulk' },
  updateProfileNotificationSettings: { method: 'post', path: '/cases/{caseId}/profiles/{profileId}/notification-settings' },
  getAlert: { method: 'get', path: '/alerts/{alertId}' },
  getProfile: { method: 'get', path: '/profile/{source}/{profileId}' },
  getLlmContent: { method: 'post', path: '/llm/get-content' },
  listRiskAttributes: { method: 'get', path: '/attributes' },
  upsertRiskAttribute: { method: 'post', path: '/attributes' },
  deleteRiskAttribute: { method: 'post', path: '/attributes/{id}/delete' },
  createRiskTemplate: { method: 'post', path: '/templates' },
  updateRiskTemplate: { method: 'post', path: '/templates/{riskTemplateId}' },
  deleteRiskTemplate: { method: 'post', path: '/templates/{riskTemplateId}/delete' },
  listRiskTemplates: { method: 'get', path: '/templates' },
  getRiskTemplate: { method: 'get', path: '/templates/{riskTemplateId}' },
  generateAiTreatmentCompletion: { method: 'post', path: '/generate-ai-treatment-completion' },
  GetTprmUsageReport: { method: 'get', path: '/reports/usage' },
  listAutoFlaggedScoreCategories: { method: 'get', path: '/auto-flagged-score-categories' },
  createAutoFlaggedScoreCategory: { method: 'post', path: '/auto-flagged-score-categories' },
  updateAutoFlaggedScoreCategory: { method: 'post', path: '/auto-flagged-score-categories/{categoryId}' },
  deleteAutoFlaggedScoreCategory: { method: 'post', path: '/auto-flagged-score-categories/{categoryId}/delete' },
  getAutoFlaggedScoreCategoryUsage: { method: 'get', path: '/auto-flagged-score-categories/{categoryId}/usage' },
  listInherentRiskAssessments: { method: 'get', path: '/inherent-risk-assessments' },
  overrideInherentRiskDimension: { method: 'post', path: '/inherent-risk-dimensions/{dimensionId}/override' },
} as const
